'use client'

import { ClockTimestampContext } from '@/components/utils/clock/ClockTimestampContext'
import { dayjs } from '@/lib/dayjs'
import { useContext } from 'react'

export function useClockTimestamp(timezone: string = dayjs.tz.guess()): dayjs.Dayjs {
  const unixTimestampNow = useContext(ClockTimestampContext)
  return dayjs.utc(unixTimestampNow).tz(timezone)
}
